import React, { useContext } from 'react';

import ClassSessionSelect from './ClassSessionSelect';
import ClassStudentSelect from './ClassStudentSelect';
import { AttendanceContext, View } from '../../context/AttendanceContext';

export interface AttendanceSelectProps {}

const AttendanceSelect: React.FC<AttendanceSelectProps> = () => {
    const { view, setStudentId, setClassSessionId } = useContext(AttendanceContext);

    const handleSelectChange = (e) => {
        const value = e.target.value as string;

        if (value === 'student-summary') {
            setStudentId('student-summary');
            return;
        }

        if (value === 'session-summary') {
            setClassSessionId('session-summary');
            return;
        }

        if (view === View.Session || view === View.SessionSummary) {
            setClassSessionId(value);
        }

        if (view === View.Student || view === View.StudentSummary) {
            setStudentId(value);
        }
    };

    switch (view) {
        case View.Student:
        case View.StudentSummary:
            return <ClassStudentSelect onChange={handleSelectChange} />;
        case View.Session:
        case View.SessionSummary:
            return <ClassSessionSelect onChange={handleSelectChange} />;
        default:
            return null;
    }
};

export default AttendanceSelect;
